function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.2917 4.33398H2.70832C1.2155 4.33398 0 5.54948 0 7.04235V18.959C0 20.4519 1.2155 21.6674 2.70832 21.6674H23.2916C24.7844 21.6674 25.9999 20.4519 25.9999 18.959V7.04235C26 5.54948 24.7845 4.33398 23.2917 4.33398ZM24.9167 18.959C24.9167 19.8549 24.1876 20.584 23.2917 20.584H2.70832C1.81238 20.584 1.08332 19.8549 1.08332 18.959V7.04235C1.08332 6.14642 1.81238 5.41735 2.70832 5.41735H23.2916C24.1876 5.41735 24.9166 6.14642 24.9166 7.04235V18.959H24.9167Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4583 7.58398H0.541684C0.242684 7.58398 0 7.82667 0 8.12567V11.3757C0 11.6747 0.242684 11.9174 0.541684 11.9174H25.4584C25.7574 11.9174 26 11.6747 26 11.3757V8.12567C26 7.82667 25.7573 7.58398 25.4583 7.58398ZM24.9167 10.834H1.08332V8.6673H24.9166V10.834H24.9167Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2917 15.166H3.79168C3.49268 15.166 3.25 15.4087 3.25 15.7077C3.25 16.0067 3.49268 16.2493 3.79168 16.2493H10.2917C10.5907 16.2493 10.8334 16.0066 10.8334 15.7076C10.8334 15.4086 10.5907 15.166 10.2917 15.166Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2917 17.334H3.79168C3.49268 17.334 3.25 17.5767 3.25 17.8757C3.25 18.1747 3.49268 18.4173 3.79168 18.4173H10.2917C10.5907 18.4173 10.8334 18.1747 10.8334 17.8757C10.8333 17.5767 10.5907 17.334 10.2917 17.334Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.1253 14.084H20.042C19.1461 14.084 18.417 14.8131 18.417 15.709V16.7923C18.417 17.6882 19.1461 18.4173 20.042 18.4173H21.1253C22.0212 18.4173 22.7503 17.6882 22.7503 16.7923V15.709C22.7503 14.8131 22.0212 14.084 21.1253 14.084ZM21.667 16.7924C21.667 17.0914 21.4243 17.334 21.1253 17.334H20.042C19.743 17.334 19.5003 17.0914 19.5003 16.7924V15.709C19.5003 15.41 19.743 15.1674 20.042 15.1674H21.1253C21.4243 15.1674 21.667 15.41 21.667 15.709V16.7924Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  fill: "white"
})));

var SvgStep2 = function SvgStep2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step2.b0b0ed24.svg";
export { ForwardRef as ReactComponent };